import axios from 'axios'

const ROOT_URL = process.env.REACT_APP_API_URI || 'http://localhost:3001';
export const axios_api_instance = axios.create({
  baseURL: ROOT_URL
});
if (localStorage.getItem('auth_jwt_token')) {
    axios_api_instance.defaults.headers.post['x-access-token'] = localStorage.getItem('auth_jwt_token');
}
axios_api_instance.defaults.headers.post['Content-Type'] = 'application/json';